import { useLayoutStore, useThemeStore } from '@realtyfeed/store';
import { NavbarIconButton } from '@realtyfeed/ui';
import { type ReactNode } from 'react';
import { Menu, Moon, Sun } from 'react-feather';
import { useTranslation } from 'react-i18next';
import type { AppShellUser } from '../type';
import { UserMenu } from './UserMenu';

export type NavbarProps = {
  user: AppShellUser | null;
  onSignOut: () => void;
  profilePath: string;
  slot?: ReactNode;
  /** Passed straight to `UserMenu`; only the vendor portal supplies one. */
};

export const Navbar = ({ user, onSignOut, profilePath, slot }: NavbarProps): ReactNode => {
  const { t } = useTranslation();
  const toggleSidebar = useLayoutStore((state) => state.toggleSidebar);
  const mode = useThemeStore((state) => state.mode);
  const toggleMode = useThemeStore((state) => state.toggleMode);

  return (
    <header className="flex h-16 shrink-0 items-center gap-3 border-b border-ds-border-default bg-ds-bg-surface px-4">
      <NavbarIconButton
        icon={<Menu size={20} />}
        onClick={toggleSidebar}
        aria-label={t('shell.toggleSidebar')}
      />

      <div className="flex-1">{slot}</div>

      <NavbarIconButton
        icon={mode === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        onClick={toggleMode}
        aria-label={mode === 'dark' ? t('shell.switchToLight') : t('shell.switchToDark')}
      />

      {user && <UserMenu user={user} onSignOut={onSignOut} profilePath={profilePath} />}
    </header>
  );
};
